import React from 'react'
import { useIntl } from 'react-intl'
import { css } from '@emotion/css'
import { IconCaretDown, IconCaretUp } from '@contrast-security-inc/design-system-foundations'
import { Link, Text } from '@contrast-security-inc/design-system-typography'
import { BaseFilterValues, NonDateFiltersValues } from '../../../types'
import { getFilterCount } from './state/utils'
import { FilterProps } from './filters'

const filterHeaderCss = css`
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 48px;
  margin-bottom: 8px;
  border-bottom: 1px #dcdcdc solid;
`

export interface AccordionWrapperProps extends Omit<FilterProps, 'updateFilter'> {
  children: React.ReactElement
}

export const AccordionWrapper = ({
  filterDef,
  filters,
  resetFilter,
  children
}: AccordionWrapperProps) => {
  const { filterMsgId, filterKey, filterType, options: { open = false } = {} } = filterDef ?? {}
  const intl = useIntl()
  const [isOpen, setIsOpen] = React.useState(open)
  const IconOpen = isOpen ? IconCaretUp : IconCaretDown

  return (
    <div
      className={css`
        display: flex;
        flex-direction: column;
      `}
    >
      <div
        data-testid={`filter-container-${filterKey}-${filterType}`}
        className={filterHeaderCss}
        onClick={() => setIsOpen(!isOpen)}
        onKeyDown={(event) => {
          if (event.code == 'Enter') {
            setIsOpen(!isOpen)
          }
        }}
        tabIndex={0}
      >
        <Text as="div" font="bodyStrong" style={{ textTransform: 'capitalize' }}>
          {intl.formatMessage({ id: filterMsgId })}
        </Text>
        <div
          className={css`
            display: flex;
            align-items: center;
            padding-right: 4px;
          `}
        >
          {filterKey && Boolean((filters[filterKey] as BaseFilterValues)?.length) && (
            <Link
              onClick={(event: React.SyntheticEvent) => {
                resetFilter(filterKey)
                event.stopPropagation()
              }}
            >
              {intl.formatMessage(
                { id: 'action_resetCount' },
                {
                  count: getFilterCount({
                    filters: filters as NonDateFiltersValues,
                    filterKey,
                    filterType
                  })
                }
              )}
            </Link>
          )}
          <IconOpen />
        </div>
      </div>
      {isOpen && children}
    </div>
  )
}
